import { Route } from 'react-router-dom';

export const mapRouteElement = (route) => (
  <Route path={route.path} element={route.element} key={route.path} />
);
